import { useData } from 'components/common-form/hooks/useData';
import { useFieldMetadata } from 'components/common-form/hooks/useFieldMetadata';
import { useFieldTranslationKey } from 'components/common-form/hooks/useFieldTranslationKey';
import { useFieldValidationError } from 'components/common-form/hooks/useFieldValidationError';
import { usePatchedFieldHighlight } from 'components/common-form/hooks/usePatchedFieldHighlight';
import { CurrencyPairSwitcher } from 'components/shared/currency-pair-switcher';
import type { CurrencyPairSwitcherData, CurrencyPairSwitcherMetadata } from 'models/forms/fields';
import { FC, useCallback } from 'react';

import type { ProductNodeBuilderProps } from '../ProductNodeBuilder.model';

export const CurrencyPairSwitcherField: FC<ProductNodeBuilderProps> = ({ node: { id }, workspaceType, tabIndex }) => {
  const { currency1, currency2, isReadOnly } = useFieldMetadata<CurrencyPairSwitcherMetadata>(id)!;
  const translationKey = useFieldTranslationKey(id);
  const [value, onChangeValue] = useData<CurrencyPairSwitcherData>(id);
  const validationError = useFieldValidationError(id, 'quote.errorMessages.');
  const patchedFieldClassName = usePatchedFieldHighlight(id);

  const onToggleCurrency = useCallback(
    (alternateCurrency: string) => {
      onChangeValue(alternateCurrency);
    },
    [onChangeValue],
  );

  const isBatchScreen = workspaceType === 'newBatch';

  return (
    <CurrencyPairSwitcher
      id={id}
      className={patchedFieldClassName}
      switchedCurrencyTranslationKey={translationKey}
      isLabelHidden={isBatchScreen}
      value={value}
      onToggleCurrency={onToggleCurrency}
      currency1={currency1}
      currency2={currency2}
      tabIndex={tabIndex}
      validationError={validationError}
    >
      {!isBatchScreen && !isReadOnly && <CurrencyPairSwitcher.Label isReadOnly={isReadOnly} />}
      {!isReadOnly && (
        <>
          <CurrencyPairSwitcher.Input />
          <CurrencyPairSwitcher.Validation />
        </>
      )}
    </CurrencyPairSwitcher>
  );
};
